import {post} from './api';

const saveLessonRecord = post('lesson-record/save');
const commentLesson = post('lesson-record/comment');

export {
    saveLessonRecord,
    commentLesson,
};
